import lazysizes from 'lazysizes';
import Waypoint from 'Waypoint';
import $ from 'jquery';

export default function (callback) {

  // lazy sizes config
  lazysizes.cfg.customMedia = {
      '--device': '(max-width: 768px)',
      '--laptop': '(max-width: 1200px)',
      '--desktop': '(max-width: 1440px)',
  };
  lazysizes.cfg.expand = 1000;

  // call resize on lazy image load to make sure waypoints checker updates positions
	document.addEventListener('lazybeforeunveil', function(e){
    if(callback && e.target && e.target.id) {
      callback(e.target.id);
    }
    Waypoint.refreshAll();
	});

}



// WEBPACK FOOTER //
// ./src/js/proj/handleLazySizes.js